import { MONTHLY_PRICE_PER_CREDIT } from "../../plans/info/ubp";

// Google Vision OCR pricing
// Prices from https://cloud.google.com/vision/pricing
// TEXT_DETECTION and DOCUMENT_TEXT_DETECTION: $1.50 per 1000 requests
const GOOGLE_VISION_COST_PER_REQUEST_USD = 1.5 / 1000;

/**
 * Convert USD cost to Roboflow credit cost
 */
function priceToCreditConversion(costPerRequestUSD: number): number {
    // At $4/credit and $0.0015/request, a margin of ~2.67x results in 1000 requests per credit
    const MARGIN = 8 / 3; // ~2.67x
    return (costPerRequestUSD * MARGIN) / MONTHLY_PRICE_PER_CREDIT;
}

/**
 * Get the credit conversion rate for Google Vision OCR.
 * Returns the number of credits per OCR request.
 */
export function getGoogleVisionOCRConversionRate(): number {
    return priceToCreditConversion(GOOGLE_VISION_COST_PER_REQUEST_USD);
}
